import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=64c55006&scoped=true&"
import script from "./RecordDetail.vue?vue&type=script&lang=js&"
export * from "./RecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecordDetail.vue?vue&type=style&index=0&id=64c55006&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c55006",
  null
  
)

export default component.exports